import { FC, ReactNode } from 'react'
import classnames from 'classnames'
import Link from './Link'

type NoticeProps = {
  title?: string | ReactNode
  body?: string | ReactNode
  ctaText?: ReactNode
  ctaPath?: string
  type?: 'info' | 'success' | 'error' | 'warning'
  size?: 'mini' | 'micro'
  layout?: 'horizontal' | 'vertical'
  className?: string
}

const Notice: FC<NoticeProps> = ({ title, body, ctaText, ctaPath, type = 'info', size, layout, className }) => {
  const noticeClass = classnames(
    'notice p',
    {
      [`notice--${type}`]: !!type,
      [`notice--${size}`]: !!size,
      [`notice--${layout}`]: !!layout,
    },
    className
  )

  const layoutClass = layout
    ? classnames('notice-layout', {
        [`notice-layout--${layout}`]: !!layout,
      })
    : null

  return (
    <div className={noticeClass}>
      {layoutClass ? (
        <div className={layoutClass}>
          <div className="notice__content">
            {title && <div className="notice__title">{title}</div>}
            {body && <div className="notice__body">{body}</div>}
          </div>
          {ctaText && ctaPath && (
            <Link href={ctaPath} className="notice__cta">
              {ctaText}
            </Link>
          )}
        </div>
      ) : (
        // Render without layout if no layout is specified
        <>
          {title && <div className="notice__title">{title}</div>}
          {body && <div className="notice__body">{body}</div>}
        </>
      )}
    </div>
  )
}

export default Notice
